import { Routes } from '@angular/router';
import { authGuard } from '#core';
import { PageNotFoundComponent, ServerErrorComponent, UnauthorizedComponent } from '#components';

export const routes: Routes = [
  {
    canActivateChild: [authGuard],
    path: 'pssrs',
    loadChildren: () => import('../features/pssrs/pssrs.routes').then(r => r.PSSR_ROUTES),
  },
  {
    canActivateChild: [authGuard],
    path: 'projects',
    loadChildren: () => import('../features/projects/projects.routes').then(r => r.PROJECT_ROUTES),
  },
  {
    canActivateChild: [authGuard],
    path: 'action-items',
    loadChildren: () => import('../features/action-items/action-items.routes').then(r => r.ACTION_ITEMS_ROUTES),
  },
  {
    canActivateChild: [authGuard],
    path: 'admin',
    loadChildren: () => import('../features/admin/admin.routes').then(r => r.ADMIN_ROUTES),
  },
  {
    canActivateChild: [authGuard],
    path: 'user',
    loadChildren: () => import('../features/user/user.routes').then(r => r.USER_ROUTES),
  },
  {
    canActivateChild: [authGuard],
    path: 'support',
    loadChildren: () => import('../features/support/support.routes').then(r => r.SUPPORT_ROUTES),
  },
  {
    canActivate: [authGuard],
    path: 'pssr-moc-import',
    loadComponent: () =>
      import('../features/pssrs/pages/pssr-moc-import/pssr-moc-import.component').then(m => m.PssrMocImportComponent),
  },
  {
    // Target of the file links the API embeds in PSSR PDF reports: /(download:file/<pssrId>/<fileGuid>)
    canActivate: [authGuard],
    path: 'file/:pssrId/:fileId',
    outlet: 'download',
    loadComponent: () =>
      import('../features/pssrs/pages/pssr-file-download/pssr-file-download.component').then(
        m => m.PssrFileDownloadComponent
      ),
  },
  {
    path: '403',
    component: UnauthorizedComponent,
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '500',
    component: ServerErrorComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      // Restore deep-link URL preserved before the Azure AD login redirect
      const returnUrl = sessionStorage.getItem('pssr_return_url');
      if (returnUrl) {
        sessionStorage.removeItem('pssr_return_url');
        localStorage.removeItem('pssr_return_url'); // clean up any legacy localStorage entry
        return returnUrl;
      }
      return '/pssrs';
    },
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
